import { RequestActions } from "@taabl/common-lib/constants/RequestActions";
import { API } from "aws-amplify";
import globalOptions from "./apiReqOptions";
import { checkForAuthError, responseData } from "./RequestLib";

export async function exportExpense(offerStartdate, periods, selectedPeriod, totalTranche, exportStart, exportEnd, trancheList, periodsToExport, company){
    try {
        let obj = {
            type: RequestActions.EXPORT,
            activeCompanyId: company.id,
            offerStartdate: offerStartdate,
            periods: periods,
            selectedPeriod: selectedPeriod,
            totalTranche: totalTranche,
            exportStart: exportStart,
            exportEnd: exportEnd,
            trancheList: trancheList,
            periodsToExport: periodsToExport
        }
        // const myInit = {
        //     queryStringParameters : queryStringParameters,
        //     body: body
        // };
        let response = await API.post(
          "taabl-api",
          `/app-api/export`,
          {
              body: obj
          }, 
          globalOptions
        );
          //`/app-api/export/test`);
        return responseData(response);
      } catch (err) {
        checkForAuthError(err);
      }
}